import React from "react";
import PropTypes from "prop-types";
import { IconComponent } from "components/common/IconComponent";
import { iconFacebook, iconInstagram, iconYoutube } from "assets/img/public-auth";

const BRAND_SOCIAL_ICONS = {
  facebook: iconFacebook,
  instagram: iconInstagram,
  youtube: iconYoutube,
};

function Social(props) {
  const { mediaList, className } = props;
  return (
    <ul className={`flex flex-wrap items-center ${className || ""}`}>
      {mediaList.map((social) => {
        const brandIcon = BRAND_SOCIAL_ICONS[social.icon];
        return (
          <li key={social.icon} className="social-item">
            <a href={social.url} target="_blank" rel="noopener noreferrer" className="social-link">
              {brandIcon ? (
                <img src={brandIcon} alt={social.icon} className="social-link__img" />
              ) : (
                <IconComponent icon={`s_${social.icon}`} />
              )}
            </a>
          </li>
        );
      })}
    </ul>
  );
}

Social.propTypes = {
  className: PropTypes.string,
  mediaList: PropTypes.array,
};

export default Social;
